import React from 'react';
import { geolocated } from 'react-geolocated';
import Geocode from 'react-geocode';
import config from '../../../../config';

class LocationFetch extends React.Component {
    async componentDidUpdate() {
        Geocode.setApiKey(config.googleApiKey);
        // Grab user's current location from browser api
        // if not available, use the auth user object's location
        if (this.props.search.geocoded === null) {
            if (!this.props.isGeolocationAvailable) {
                console.log('Your browser does not support Geolocation');
            } else if (!this.props.isGeolocationEnabled) {
                console.log('Geolocation is not enabled');
            } else if (this.props.coords) {
                console.log('lat', this.props.coords.latitude, 'lng', this.props.coords.longitude);
                const location = await getGeocodedLocation(this.props.coords.latitude, this.props.coords.longitude);
                this.props.setLocationInReducer(location);
            } else {
                console.log('no coords - use user object');
                if (this.props.auth && this.props.auth.user && this.props.auth.user.location && this.props.auth.user.location.display && this.props.auth.user.location.latLng && this.props.auth.user.location.latLng[0] && this.props.auth.user.location.latLng[1]) {
                    this.props.setLocationInReducer({
                        location: this.props.auth.user.location.display,
                        lat: this.props.auth.user.location.latLng[0],
                        lng: this.props.auth.user.location.latLng[1],
                    });
                }
            }
        }
    }

    render() {
        return <div />;
    }
}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    },
    suppressLocationOnMount: true,
})(LocationFetch);

export const getGeocodedLocation = async (latitude, longitude) => {
    try {
        Geocode.setApiKey(config.googleApiKey);
        const response = await Geocode.fromLatLng(latitude, longitude);
        if (response && response.results && response.results.length > 0) {
            let city; let state; let
                country;
            for (let i = 0; i < response.results[0].address_components.length; i += 1) {
                if (response.results[0].address_components[i].types.includes('neighborhood')) {
                    city = response.results[0].address_components[i].short_name;
                    console.log('city', city);
                }
                if (response.results[0].address_components[i].types.includes('locality')) {
                    city = response.results[0].address_components[i].short_name;
                    console.log('city', city);
                }
                if (response.results[0].address_components[i].types.includes('administrative_area_level_1')) {
                    state = response.results[0].address_components[i].short_name;
                    console.log('state', state);
                }
                if (response.results[0].address_components[i].types.includes('country') && response.results[0].address_components[i].short_name !== 'US') {
                    country = response.results[0].address_components[i].long_name;
                    console.log('country', country);
                }
            }
            const address = `${city && city !== 'undefined' ? city : ''}${city && country ? ', ' : ''}${country || ''}${state ? `, ${state}` : ''}`;
            return {
                location: address,
                lat: latitude,
                lng: longitude,
            };
        }
        return {
            location: 'My location',
            lat: latitude,
            lng: longitude,
        };
    } catch (error) {
        return {
            location: 'My location',
            lat: latitude,
            lng: longitude,
        };
    }
};
